export const DEBOUNCE_DELAY = 500;

export default {};



// WEBPACK FOOTER //
// ./src/config/constants.js